export const SERVER = {
  FRONT: {
    CPU: [{ rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_' }, { rsctypeId: 'CPU', rscId: 'SYS_USERATE', rscKey: '_' }, { rsctypeId: 'CPU', rscId: 'USER_USERATE', rscKey: '_' }],
    MEM: [
      { rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_' },
      { rsctypeId: 'MEM_SWP', rscId: 'USERATE', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_SCAN', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_OUT', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_FREE', rscKey: '_' },
    ],
    PROCESS: [
      { rsctypeId: 'PROCSTAT', rscId: 'PROC_ZOMBI_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCCOUNT', rscId: 'PROC_CPU_MAX_OCCUPY_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCCOUNT', rscId: 'PROC_MEM_MAX_OCCUPY_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCSTAT', rscId: 'PROC_TOT_COUNT', rscKey: '_' },
    ],
    DISK: [{ rsctypeId: 'DISK', rscId: 'DISK_USERATE', rscKey: '_' }, { rsctypeId: 'DISK', rscId: 'DISK_TOTSIZE', rscKey: '_' }, { rsctypeId: 'DISK', rscId: 'DISK_USEDSIZE', rscKey: '_' }, { rsctypeId: 'DISK', rscId: 'DISK_AVSIZE', rscKey: '_' }],
    DISKIO: [
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_BUSY', rscKey: '_' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_AVQUEUE', rscKey: '_' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_RW_S', rscKey: '_' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_BLK_S', rscKey: '_' },
    ],
    SESSION: [
      { rsctypeId: 'SESSIONSTATUS', rscId: 'ESTABLISHED_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'SYN_RCVD_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'SYN_SENT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'FIN_WAIT1_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'FIN_WAIT2_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'TIME_WAIT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'CLOSE_WAIT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'CLOSED_STATUS', rscKey: '_' },
      { rsctypeId: 'TCP_SESSION', rscId: 'SESSION_CONNECTED_TCP', rscKey: '_' },
      { rsctypeId: 'PORTSCANCOUNT', rscId: 'PORTSCAN_NO_AUTH_CONNECT_COUNT', rscKey: '_' }],
    USERCONN: [{ rsctypeId: 'USERCONN', rscId: 'USERCONN_COUNT', rscKey: '_' }],
    APPLOG: [
      // { rsctypeId: 'APPLOG', rscId: 'USERATE', rscKey: '_' },
    ],
    NETIO: [
      { rsctypeId: 'NETIO', rscId: 'NETIO_BPS_IN', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_BPS_OUT', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_PKT_IN', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_PKT_OUT', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_ERRPKT_IN', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_ERRPKT_OUT', rscKey: '_' },
    ],
  },
  BACK: {
    CPU: [{ rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_' }, { rsctypeId: 'CPU', rscId: 'SYS_USERATE', rscKey: '_' }, { rsctypeId: 'CPU', rscId: 'USER_USERATE', rscKey: '_' }],
    MEM: [
      { rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_' },
      { rsctypeId: 'MEM_SWP', rscId: 'USERATE', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_SCAN', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_OUT', rscKey: '_' },
      { rsctypeId: 'PAGE', rscId: 'PAGE_FREE', rscKey: '_' },
    ],
    PROCESS: [
      { rsctypeId: 'PROCCOUNT', rscId: 'MAJOR_PROC_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCSTAT', rscId: 'PROC_ZOMBI_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCCOUNT', rscId: 'PROC_CPU_MAX_OCCUPY_COUNT', rscKey: '_' },
      { rsctypeId: 'PROCCOUNT', rscId: 'PROC_MEM_MAX_OCCUPY_COUNT', rscKey: '_' },
    ],
    DISK: [{ rsctypeId: 'DISK', rscId: 'DISK_USERATE' }],
    DISKIO: [
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_BUSY' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_AVQUEUE', rscKey: '_' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_RW_S', rscKey: '_' },
      { rsctypeId: 'DISKIO', rscId: 'DISKIO_BLK_S', rscKey: '_' },
    ],
    SESSION: [
      { rsctypeId: 'SESSIONSTATUS', rscId: 'ESTABLISHED_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'SYN_RCVD_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'SYN_SENT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'FIN_WAIT1_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'FIN_WAIT2_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'TIME_WAIT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'CLOSE_WAIT_STATUS', rscKey: '_' },
      { rsctypeId: 'SESSIONSTATUS', rscId: 'CLOSED_STATUS', rscKey: '_' },
      { rsctypeId: 'PORTSCANCOUNT', rscId: 'PORTSCAN_NO_AUTH_CONNECT_COUNT', rscKey: '_' },
    ],
    USERCONN: [
      { rsctypeId: 'USERCONN', rscId: 'USERCONN_COUNT', rscKey: '_' },
    ],
    APPLOG: [
      { rsctypeId: 'APPLOG', rscId: 'USERATE', rscKey: '_' },
    ],
    NETIO: [
      { rsctypeId: 'NETIO', rscId: 'NETIO_BPS_IN', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_BPS_OUT', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_PKT_IN', rscKey: '_' },
      { rsctypeId: 'NETIO', rscId: 'NETIO_PKT_OUT', rscKey: '_' },
    ],
  },
};

export const NETDEVICE = {
  FRONT: {
    POWER: [{ rsctypeId: 'POE', rscId: 'POWER_CONSUMED', rscKey: '_' }], /* POE */
    CPU: [{ rsctypeId: 'DEVICE_PERF', rscId: 'CPU_USERATE', rscKey: '_' }],
    MEM: [{ rsctypeId: 'DEVICE_PERF', rscId: 'MEM_USERATE', rscKey: '_' }],
    TEMP: [{ rsctypeId: 'DEVICE_PERF', rscId: 'DEVICE_TEMP', rscKey: '_' }],
    RESPONSETIME: [{ rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_ICMP', rscKey: '_' }, { rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_SNMP', rscKey: '_' }],
    SYSLOG: [],
    SNMPTRAP: [],
    TRAFFIC: [
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_IN' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_OUT' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_PPS_IN' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_PPS_OUT' },
      { rsctypeId: 'DEVICE_TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN' },
      { rsctypeId: 'DEVICE_TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT' },
    ],
  },
  BACK: {
    POWER: [{ rsctypeId: 'POE', rscId: 'POWER_CONSUMED', rscKey: '_' }], /* POE */
    CPU: [{ rsctypeId: 'DEVICE_PERF', rscId: 'CPU_USERATE', rscKey: '_' }],
    MEM: [{ rsctypeId: 'DEVICE_PERF', rscId: 'MEM_USERATE', rscKey: '_' }],
    TEMP: [{ rsctypeId: 'DEVICE_PERF', rscId: 'DEVICE_TEMP', rscKey: '_' }],
    RESPONSETIME: [{ rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_ICMP', rscKey: '_' }, { rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_SNMP', rscKey: '_' }],
    SYSLOG: [{ rsctypeId: 'SYSLOG', rscId: 'UNCHECKED_SYSLOG', rscKey: '_' }],
    SNMPTRAP: [{ rsctypeId: 'SNMPTRAP', rscId: 'UNCHECKED_SNMPTRAP', rscKey: '_' }],
    TRAFFIC: [
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_' },
      { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_' },
      { rsctypeId: 'DEVICE_TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_' },
      { rsctypeId: 'DEVICE_TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_' },
    ],
  },
};

export const NETINTERFACE = {
  FRONT: {
    BPS: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' }],
    PPS: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_' }],
    USERATE: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_OUT', rscKey: '_' }],
    ERROR: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_' }],
    DISCARD: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_OUT', rscKey: '_' }],
    CRC: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_CRC_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_COLLISION_OUT', rscKey: '_' }],
    PPSB: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_OUT', rscKey: '_' }],
    PPSM: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_OUT', rscKey: '_' }],
  },
  BACK: {
    BPS: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' }],
    PPS: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_' }],
    USERATE: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_OUT', rscKey: '_' }],
    ERROR: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_' }],
    DISCARD: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_OUT', rscKey: '_' }],
    CRC: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_CRC_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_COLLISION_OUT', rscKey: '_' }],
    PPSB: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_OUT', rscKey: '_' }],
    PPSM: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_OUT', rscKey: '_' }],
  },
};

export const DATABASE = {
  FRONT: {
    PROC: {
      INFORMIX: [
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_ADM_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_AIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_CPU_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_LIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_MSC_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_PIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_TLI_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      TIBERO: [
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_LARC_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_CKPT_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_DBWR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_LGWR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_MTHR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_AGENT_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      MSSQL: [
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_CHECKPOINT_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LAZY_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LOCK_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LOG_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_SIGNAL_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_TASK_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      SYBASE: [
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_ASTC_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_CHECKPOINT_SLEEP_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_DEADLOCK_TUNE_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_DTC_COMMIT_SVC_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HBC_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_CHORES_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_WASH_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_MIRROR_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_NETWORK_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_PORT_MANAGER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_SHUTDOWN_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      MYSQL: [
        { rsctypeId: 'MY_PROC', rscId: 'DBMY_THREADS_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      ORACLE: [
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_ARCH_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_CKPT_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_DBWR_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_LGWR_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_PMON_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_RECO_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_SMON_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      CUBRID: [
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BROKER_CONNECT_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BROKER_JOB_QUEUE_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BUSY_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_CLIENT_WAIT_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_CLOSE_WAIT_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_IDLE_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_TOTAL_CAS_COUNT', rscKey: '_' },
      ],
      DB2: [
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      POSTGRESQL: [
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      ALTIBASE: [
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_POLL_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_EXECUTE_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_MEM_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_MEM_DELTHR_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_DISK_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_DISK_DELTHR_COUNT', rscKey: '_' },
      ],
    },
    SESSION: {
      TOTAL: [
        { rsctypeId: 'SESS', rscId: 'DB_SESS_COUNT', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_ACTIVE_COUNT', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_USERATE', rscKey: '_' },
      ],
    },
    LOCK: {
      TOTAL: [
        { rsctypeId: 'LOCK', rscId: 'DB_LOCK_COUNT', rscKey: '_' },
        { rsctypeId: 'LOCK', rscId: 'DB_DEADLOCK_COUNT', rscKey: '_' },
        { rsctypeId: 'LOCK', rscId: 'DB_LOCK_USERATE', rscKey: '_' },
      ],
    },
    MEM: {
      INFORMIX: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_READ_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_WRITE_CACHE_HITRATIO', rscKey: '_' },
      ],
      TIBERO: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_DIC_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_LIB_CACHE_HITRATIO', rscKey: '_' },
      ],
      MYSQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MY_MEMSTAT', rscId: 'DBMY_THREAD_CACHE_HITRATIO', rscKey: '_' },
      ],
      SYBASE: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'SY_MEMSTAT', rscId: 'DBSY_PROCEDURE_CACHE_HITRATIO', rscKey: '_' },
      ],
      MSSQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_PROCEDURE_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_LOG_CACHE_HITRATIO', rscKey: '_' },
      ],
      ORACLE: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_LIB_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_DIC_CACHE_HITRATIO', rscKey: '_' },
      ],
      CUBRID: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
      ],
      DB2: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_PKG_HITRATIO', rscKey: '_' },
        { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_CAT_HITRATIO', rscKey: '_' },
      ],
      POSTGRESQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
      ],
      ALTIBASE: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'AT_MEMSTAT', rscId: 'DBAT_BUF_PAGE_HITRATIO', rscKey: '_' },
      ],
    },
    TABLESPACE: {
      TOTAL: [
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USERATE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_TOTSIZE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USEDSIZE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_AVSIZE', rscKey: '_' },
      ],
    },
    HOST: {
      TOTAL: [
        { rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_' },
        { rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'MEM_SWP', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'DISK', rscId: 'DISK_USERATE', rscKey: '_' },
      ],
    },
  },
  BACK: {
    PROC: {
      INFORMIX: [
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_ADM_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_AIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_CPU_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_LIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_MSC_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_PIO_COUNT', rscKey: '_' },
        { rsctypeId: 'IN_PROC', rscId: 'DBIN_TLI_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      TIBERO: [
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_LARC_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_CKPT_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_DBWR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_LGWR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_MTHR_COUNT', rscKey: '_' },
        { rsctypeId: 'TB_PROC', rscId: 'DBTB_PROC_AGENT_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      MSSQL: [
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_CHECKPOINT_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LAZY_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LOCK_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_LOG_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_SIGNAL_COUNT', rscKey: '_' },
        { rsctypeId: 'MS_PROC', rscId: 'DBMS_PROC_TASK_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      SYBASE: [
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_ASTC_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_CHECKPOINT_SLEEP_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_DEADLOCK_TUNE_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_DTC_COMMIT_SVC_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HBC_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_CHORES_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_HK_WASH_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_MIRROR_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_NETWORK_HANDLER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_PORT_MANAGER_COUNT', rscKey: '_' },
        { rsctypeId: 'SY_PROC', rscId: 'DBSY_SHUTDOWN_HANDLER_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      MYSQL: [
        { rsctypeId: 'MY_PROC', rscId: 'DBMY_THREADS_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      ORACLE: [
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_ARCH_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_CKPT_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_DBWR_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_LGWR_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_PMON_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_RECO_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_PROC', rscId: 'DBOR_PROC_SMON_COUNT', rscKey: '_' },
        // { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      CUBRID: [
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BROKER_CONNECT_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BROKER_JOB_QUEUE_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_BUSY_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_CLIENT_WAIT_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_CLOSE_WAIT_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_IDLE_CAS_COUNT', rscKey: '_' },
        { rsctypeId: 'CU_PROC', rscId: 'DBCU_TOTAL_CAS_COUNT', rscKey: '_' },
      ],
      DB2: [
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      POSTGRESQL: [
        { rsctypeId: 'PROC', rscId: 'DB_PROC_TOTAL_COUNT', rscKey: '_' },
      ],
      ALTIBASE: [
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_POLL_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_EXECUTE_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_MEM_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_MEM_DELTHR_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_DISK_GC_COUNT', rscKey: '_' },
        { rsctypeId: 'AT_PROC', rscId: 'DBAT_PROC_DISK_DELTHR_COUNT', rscKey: '_' },
      ],
    },
    SESSION: {
      TOTAL: [
        { rsctypeId: 'SESS', rscId: 'DB_SESS_COUNT', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_ACTIVE_COUNT', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_USERATE', rscKey: '_' },
      ],
    },
    LOCK: {
      TOTAL: [
        { rsctypeId: 'LOCK', rscId: 'DB_LOCK_COUNT', rscKey: '_' },
        { rsctypeId: 'LOCK', rscId: 'DB_DEADLOCK_COUNT', rscKey: '_' },
      ],
    },
    MEM: {
      INFORMIX: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_READ_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_WRITE_CACHE_HITRATIO', rscKey: '_' },
      ],
      TIBERO: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_DIC_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_LIB_CACHE_HITRATIO', rscKey: '_' },
      ],
      MYSQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MY_MEMSTAT', rscId: 'DBMY_THREAD_CACHE_HITRATIO', rscKey: '_' },
      ],
      SYBASEIQ: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'SY_MEMSTAT', rscId: 'DBSY_PROCEDURE_CACHE_HITRATIO', rscKey: '_' },
      ],
      MSSQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_PROCEDURE_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_LOG_CACHE_HITRATIO', rscKey: '_' },
      ],
      ORACLE: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_LIB_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_DIC_CACHE_HITRATIO', rscKey: '_' },
      ],
      CUBRID: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
      ],
      DB2: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_PKG_HITRATIO', rscKey: '_' },
        { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_CAT_HITRATIO', rscKey: '_' },
      ],
      POSTGRESQL: [
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
      ],
    },
    TABLESPACE: {},
    HOST: {
      TOTAL: [
        { rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_' },
        { rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'DISK', rscId: 'DISK_USERATE', rscKey: '_' },
      ],
    },
  },
};

export const E2E = {
  FRONT: {
    RESPONSETIME: [
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_NAMELOOKUP' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_HOST_SERVER_CONNECT' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_SERVICE_WAIT' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_FILE_TRANSFER' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_DB_SERVICE' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_TOTAL' },
    ],
    AVAIL: [],
    STATUSCODE: [
      { rsctypeId: 'SERVICESTATUS', rscId: 'SERVICE_STATUS_CODE' },
    ],
  },
  BACK: {
    RESPONSETIME: [
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_TOTAL' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_NAMELOOKUP' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_HOST_SERVER_CONNECT' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_SERVICE_WAIT' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_FILE_TRANSFER' },
      { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_DB_SERVICE' },
    ],
    AVAIL: [{ rsctypeId: 'SERVICESTATUS', rscId: 'AVAIL' }],
    STATUSCODE: [
      { rsctypeId: 'SERVICESTATUS', rscId: 'SERVICE_STATUS_CODE' },
    ],
  },
};

export const SENSOR = {
  // UPS
  FUPS: {
    FRONT: {
      VOLTAGE: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_VOLTAGE', rscKey: '_' },
      ],
      CURRENT: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_CURRENT', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_CURRENT', rscKey: '_' },
      ],
      FREQUENCY: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_FREQUENCY', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_FREQUENCY', rscKey: '_' },
      ],
      TEMPERATURE: [{ rsctypeId: 'FUPS', rscId: 'TEMPERATURE', rscKey: '_' }],
      CAPACITY: [{ rsctypeId: 'FUPS', rscId: 'CAPACITY', rscKey: '_' }],
      LOADING: [{ rsctypeId: 'FUPS', rscId: 'LOADING', rscKey: '_' }],
      BATTERY: [
        { rsctypeId: 'FUPS', rscId: 'BATTERY_STATUS', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_CURRENT', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE_ERROR', rscKey: '_' },
      ],
      // INTERRUPT: [{ rsctypeId: 'FUPS', rscId: 'INTERRUPT_INPUT_POWER', rscKey: '_' }],
      // BYPASS: [{ rsctypeId: 'FUPS', rscId: 'OPER_BYPASS', rscKey: '_' }],
      INFO: [
        { rsctypeId: 'FUPS', rscId: 'MODEL_NAME', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'INTERRUPT_INPUT_POWER', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OPER_BYPASS', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'SOFTWARE_VERSION', rscKey: '_' },
      ],
    },
    BACK: {
      VOLTAGE: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_VOLTAGE', rscKey: '_' },
      ],
      CURRENT: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_CURRENT', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_CURRENT', rscKey: '_' },
      ],
      FREQUENCY: [
        { rsctypeId: 'FUPS', rscId: 'INPUT_FREQUENCY', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OUTPUT_FREQUENCY', rscKey: '_' },
      ],
      TEMPERATURE: [{ rsctypeId: 'FUPS', rscId: 'TEMPERATURE', rscKey: '_' }],
      CAPACITY: [{ rsctypeId: 'FUPS', rscId: 'CAPACITY', rscKey: '_' }],
      LOADING: [{ rsctypeId: 'FUPS', rscId: 'LOADING', rscKey: '_' }],
      BATTERY: [
        { rsctypeId: 'FUPS', rscId: 'BATTERY_STATUS', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_CURRENT', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE_ERROR', rscKey: '_' },
      ],
      // INTERRUPT: [{ rsctypeId: 'FUPS', rscId: 'INTERRUPT_INPUT_POWER', rscKey: '_' }],
      // BYPASS: [{ rsctypeId: 'FUPS', rscId: 'OPER_BYPASS', rscKey: '_' }],
      INFO: [
        { rsctypeId: 'FUPS', rscId: 'MODEL_NAME', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'INTERRUPT_INPUT_POWER', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'OPER_BYPASS', rscKey: '_' },
        { rsctypeId: 'FUPS', rscId: 'SOFTWARE_VERSION', rscKey: '_' },
      ],
    },
  },
  // 항온항습기
  FTHEHYGRO: {
    FRONT: {
      TEMPERATURE: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_TEMPERATURE', rscKey: '_' },
      ],
      HUMIDITY: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_HUMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_HUMMIDITY', rscKey: '_' },
      ],
      RUNNING: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_RUNNING_STATUS', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_COLDROOM', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_WARMROOM', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_INCREASE_HUMMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_DECREASE_HUMMIDITY', rscKey: '_' },
      ],
      WARN: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HOT_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HIGH_HUMMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_LEAK', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HUMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP1', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP2', rscKey: '_' },
      ],
    },
    BACK: {
      TEMPERATURE: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_TEMPERATURE', rscKey: '_' },
      ],
      HUMIDITY: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_HUMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_HUMMIDITY', rscKey: '_' },
      ],
      RUNNING: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'SET_RUNNING_STATUS', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_COLDROOM', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_WARMROOM', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_INCREASE_HUMMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_DECREASE_HUMMIDITY', rscKey: '_' },
      ],
      WARN: [
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HOT_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HIGH_HUMMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_LEAK', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HUMIDITY', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP1', rscKey: '_' },
        { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP2', rscKey: '_' },
      ],
    },
  },
  // 온습도 센서
  FTH: {
    FRONT: {
      TEMPERATURE: [{ rsctypeId: 'FTH', rscId: 'TEMPERATURE', rscKey: '_' }],
      HUMIDITY: [{ rsctypeId: 'FTH', rscId: 'HUMIDITY', rscKey: '_' }],
    },
    BACK: {
      TEMPERATURE: [{ rsctypeId: 'FTH', rscId: 'TEMPERATURE', rscKey: '_' }],
      HUMIDITY: [{ rsctypeId: 'FTH', rscId: 'HUMIDITY', rscKey: '_' }],
    },
  },
  // 선형온도 센서
  FTEMP: {
    FRONT: {},
    BACK: {},
  },
  // 누수 센서
  FWLDS: {
    FRONT: {
      WARN: [{ rsctypeId: 'FWLDS', rscId: 'WARN_LOSSOFFLOW', rscKey: '_' }],
    },
    BACK: {
      WARN: [{ rsctypeId: 'FWLDS', rscId: 'WARN_LOSSOFFLOW', rscKey: '_' }],
    },
  },
  // 소방 설비
  FFIREDS: {
    FRONT: [
      { rsctypeId: 'FFIREDS', rscId: 'FDA', rscKey: '_' },
      { rsctypeId: 'FFIREDS', rscId: 'FDB', rscKey: '_' },
      { rsctypeId: 'FFIREDS', rscId: 'FDH', rscKey: '_' },
    ],
    // FRONT: {
    //   FDA: [{ rsctypeId: 'FFIREDS', rscId: 'FDA', rscKey: '_' }],
    //   FDB: [{ rsctypeId: 'FFIREDS', rscId: 'FDB', rscKey: '_' }],
    //   FDH: [{ rsctypeId: 'FFIREDS', rscId: 'FDH', rscKey: '_' }],
    // },
    // BACK: {
    //   FDA: [{ rsctypeId: 'FFIREDS', rscId: 'FDA', rscKey: '_' }],
    //   FDB: [{ rsctypeId: 'FFIREDS', rscId: 'FDB', rscKey: '_' }],
    //   FDH: [{ rsctypeId: 'FFIREDS', rscId: 'FDH', rscKey: '_' }],
    // },
  },
  // 도어 센서
  FSENSOR: {
    FRONT: {
      DOOR: [{ rsctypeId: 'FSENSOR', rscId: 'FMS_DOOR_STATUS', rscKey: '_' }],
    },
    BACK: {
      DOOR: [{ rsctypeId: 'FSENSOR', rscId: 'FMS_DOOR_STATUS', rscKey: '_' }],
    },
  },
  // 분전반
  FVSBMS: {
    FRONT: {
      PVOL: [
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      ],
      LVOL: [
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      ],
      CURRENT: [
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_T', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FVSBMS', rscId: 'POWER', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'POWER_FACTOR', rscKey: '_' },
      ],
      POWERQ: [
        { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR_Q', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'INTEGRATE_PWR_Q', rscKey: '_' },
      ],
      FREQUENCY: [{ rsctypeId: 'FVSBMS', rscId: 'FREQUENCY', rscKey: '_' }],
      RADIATION: [
        { rsctypeId: 'FVSBMS', rscId: 'HORIZONTAL_RADIATION', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'TILT_RADIATION', rscKey: '_' },
      ],
      TEMPERATURE: [
        { rsctypeId: 'FVSBMS', rscId: 'OUTSIDE_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'MODULE_TEMPERATURE', rscKey: '_' },
      ],
    },
    BACK: {
      PVOL: [
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      ],
      LVOL: [
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      ],
      CURRENT: [
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_R', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_S', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'CURRENT_T', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FVSBMS', rscId: 'POWER', rscKey: '_' },
        // { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR', rscKey: '_' },
        // { rsctypeId: 'FVSBMS', rscId: 'POWER_FACTOR', rscKey: '_' },
      ],
      POWERF: [
        { rsctypeId: 'FVSBMS', rscId: 'POWER_FACTOR', rscKey: '_' },
      ],
      POWERQ: [
        // { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR_Q', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'INTEGRATE_PWR_Q', rscKey: '_' },
      ],
      FREQUENCY: [{ rsctypeId: 'FVSBMS', rscId: 'FREQUENCY', rscKey: '_' }],
      RADIATION: [
        { rsctypeId: 'FVSBMS', rscId: 'HORIZONTAL_RADIATION', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'TILT_RADIATION', rscKey: '_' },
      ],
      TEMPERATURE: [
        { rsctypeId: 'FVSBMS', rscId: 'OUTSIDE_TEMPERATURE', rscKey: '_' },
        { rsctypeId: 'FVSBMS', rscId: 'MODULE_TEMPERATURE', rscKey: '_' },
      ],
    },
  },
  // 발전기
  FGCU: {
    FRONT: {
      PVOL: [
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      ],
      LVOL: [
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      ],
      PCUR: [
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_T', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FGCU', rscId: 'ACTIVE_PWR', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'REACTIVE_PWR', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'APPARENT_PWR', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'POWER_FACTOR', rscKey: '_' },
      ],
      FREQUENCY: [{ rsctypeId: 'FGCU', rscId: 'GEN_FREQUENCY', rscKey: '_' }],
      BATTERY: [{ rsctypeId: 'FGCU', rscId: 'BATTERY_VOLTAGE', rscKey: '_' }],
      OIL: [{ rsctypeId: 'FGCU', rscId: 'OIL_PRESS', rscKey: '_' }],
      WATER: [{ rsctypeId: 'FGCU', rscId: 'WATER_TEMP', rscKey: '_' }],
    },
    BACK: {
      PVOL: [
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      ],
      LVOL: [
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      ],
      PCUR: [
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_R', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_S', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_T', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FGCU', rscId: 'APPARENT_PWR', rscKey: '_' },
        { rsctypeId: 'FGCU', rscId: 'ACTIVE_PWR', rscKey: '_' },
        // { rsctypeId: 'FGCU', rscId: 'REACTIVE_PWR', rscKey: '_' },
        // { rsctypeId: 'FGCU', rscId: 'POWER_FACTOR', rscKey: '_' },
      ],
      FREQUENCY: [{ rsctypeId: 'FGCU', rscId: 'GEN_FREQUENCY', rscKey: '_' }],
      BATTERY: [{ rsctypeId: 'FGCU', rscId: 'BATTERY_VOLTAGE', rscKey: '_' }],
      OIL: [{ rsctypeId: 'FGCU', rscId: 'OIL_PRESS', rscKey: '_' }],
      WATER: [{ rsctypeId: 'FGCU', rscId: 'WATER_TEMP', rscKey: '_' }],
    },
  },
  // 정류기
  FRT: {
    FRONT: {
      DC: [
        { rsctypeId: 'FRT', rscId: 'DC_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'DC_CURRENT', rscKey: '_' },
      ],
      LOAD: [
        { rsctypeId: 'FRT', rscId: 'LOAD_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'LOAD_CURRENT', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'LOAD_FACTOR', rscKey: '_' },
      ],
      BATTERY: [
        { rsctypeId: 'FRT', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'BATTERY_CURRENT', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'BATTERY_CHARGING', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_A', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_B', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_C', rscKey: '_' },
      ],
      CELL: [
        { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VLOTAGE', rscKey: '_' },
      ],
    },
    BACK: {
      DC: [
        { rsctypeId: 'FRT', rscId: 'DC_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'DC_CURRENT', rscKey: '_' },
      ],
      LOAD: [
        { rsctypeId: 'FRT', rscId: 'LOAD_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'LOAD_CURRENT', rscKey: '_' },
      ],
      BATTERY: [
        { rsctypeId: 'FRT', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'BATTERY_CURRENT', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'BATTERY_CHARGING', rscKey: '_' },
      ],
      POWER: [
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_A', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_B', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_C', rscKey: '_' },
      ],
      CELL: [
        { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VLOTAGE', rscKey: '_' },
      ],
    },
  },
};
// hypervisor - VMWARE
export const VIRTUAL = {
  // 호스트 클러스터
  VCL: {
    FRONT: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [
        { rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' },
      ],
      MEM: [
        { rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 호스트
  VHO: {
    FRONT: {
      CPU: [
        { rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' },
      ],
      MEM: [
        { rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' },
      ],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [
        { rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' },
      ],
      MEM: [
        { rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' },
      ],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 가상머신
  VVM: {
    FRONT: {
      CPU: [
        { rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' },
      ],
      MEM: [
        { rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' },
      ],
      DISK: [
        { rsctypeId: 'VVM_DISK', rscId: 'PROVISIONING_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' },
      ],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [
        { rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' },
      ],
      MEM: [
        { rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' },
      ],
      DISK: [
        { rsctypeId: 'VVM_DISK', rscId: 'PROVISIONING_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' },
      ],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 스토리지 클러스터
  VDSC: {
    FRONT: {
      DISK: [
        { rsctypeId: 'VDSC_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
    BACK: {
      DISK: [
        { rsctypeId: 'VDSC_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDSC_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
  },
  // 스토리지
  VDS: {
    FRONT: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
    BACK: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
  },
};
// hypervisor - KVM
export const VIRTUAL_KVM = {
  VVM: {
    FRONT: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISK: [{ rsctypeId: 'VVM_DISK', rscId: 'PROVISIONING_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISK: [{ rsctypeId: 'VVM_DISK', rscId: 'PROVISIONING_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
};
// hypervisor - HYPERV
export const VIRTUAL_HYPERV = {
  // 호스트 클러스터
  VCL: {
    FRONT: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
    },
  },
  // 호스트
  VHO: {
    FRONT: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // VM
  VVM: {
    FRONT: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISK: [{ rsctypeId: 'VVM_DISK', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISK: [{ rsctypeId: 'VVM_DISK', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
};

// hypervisor - XENSERVER
export const VIRTUAL_XENSERVER = {
  // 호스트 클러스터
  VCL: {
    FRONT: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 호스트
  VHO: {
    FRONT: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 가상머신
  VVM: {
    FRONT: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 스토리지
  VDS: {
    FRONT: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
    BACK: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
  },
};
// hypervisor - RHEV
export const VIRTUAL_RHEV = {
  // 호스트 클러스터
  VCL: {
    FRONT: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VCL_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VCL_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }],
      NETIO: [
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 호스트
  VHO: {
    FRONT: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VHO_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VHO_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 가상머신
  VVM: {
    FRONT: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
    BACK: {
      CPU: [{ rsctypeId: 'VVM_CPU', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }],
      MEM: [{ rsctypeId: 'VVM_MEM', rscId: 'TOTAL_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USED_CAPACITY', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }],
      DISKIO: [
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_' },
        { rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
      ],
      NETIO: [
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
        { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
      ],
    },
  },
  // 스토리지
  VDS: {
    FRONT: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
    BACK: {
      DISK: [
        { rsctypeId: 'VDS_STORAGE', rscId: 'TOTAL_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USED_CAPACITY', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        { rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_' }],
    },
  },
};

export const APM = {
  TPS: [{ rsctypeId: 'SERVICE', rscId: 'TPS', rscKey: '_' }, { rsctypeId: 'ENDUSER', rscId: 'AJAX_TPS', rscKey: '_' }, { rsctypeId: 'JDBC', rscId: 'SQL_TPS', rscKey: '_' }],
  RESPONSE: [{ rsctypeId: 'SERVICE', rscId: 'ELAPSED_TIME', rscKey: '_' }, { rsctypeId: 'SERVICE', rscId: 'APITIME_BY_SERVICE', rscKey: '_' }, { rsctypeId: 'SERVICE', rscId: 'SQLTIME_BY_SERVICE', rscKey: '_' }],
  JVM: [{ rsctypeId: 'JVM', rscId: 'HEAP_USAGE', rscKey: '_' }, { rsctypeId: 'JVM', rscId: 'PERM_PERCENT', rscKey: '_' }],
  GCTIME: [{ rsctypeId: 'JVM', rscId: 'GC_TIME', rscKey: '_' }],
  HOST: [{ rsctypeId: 'HOST', rscId: 'CPU', rscKey: '_' }, { rsctypeId: 'HOST', rscId: 'SWAP', rscKey: '_' }, { rsctypeId: 'HOST', rscId: 'MEM', rscKey: '_' }],
  SERVICE: [{ rsctypeId: 'SERVICE', rscId: 'RECENT_USER', rscKey: '_' }, { rsctypeId: 'SERVICE', rscId: 'SERVICE_COUNT', rscKey: '_' }],
};

// Y축 좌우 제공차트 - combo-multi-axes
export const MULTI_CHART = {
  NETDEVICE_TRAFFIC: {
    LEFT: [{ rscUnit: 'bps' }, { rscUnit: 'pps' }],
    RIGHT: [{ rscUnit: '%' }],
  },
  FGCU_POWER: {
    LEFT: [{ rscUnit: 'kVA' }],
    RIGHT: [{ rscUnit: 'kW' }],
  },
  FRT_DC: {
    LEFT: [{ rscUnit: 'V' }],
    RIGHT: [{ rscUnit: 'A' }],
  },
  FRT_LOAD: {
    LEFT: [{ rscUnit: 'V' }],
    RIGHT: [{ rscUnit: 'A' }],
  },
  FRT_BATTERY: {
    LEFT: [{ rscUnit: 'V' }],
    RIGHT: [{ rscUnit: 'A' }],
  },
  SEVER_NETIO: {
    LEFT: [{ rscUnit: 'bps' }, { rscUnit: 'pps' }],
    RIGHT: [{ rscUnit: 'count/sec' }],
  },
};

export const AP_CONTROLLER = {
  FRONT: {
    CLIENT: [
      { rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'CLIENT_COUNT', rscKey: '_' },
    ],
    ROGUE: [
      { rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'ROGUE_AP_COUNT', rscKey: '_' },
    ],
    WIRELESSAP_TOPN: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_' },
    ],
    POWER: NETDEVICE.FRONT.POWER,
    CPU: NETDEVICE.FRONT.CPU,
    MEM: NETDEVICE.FRONT.MEM,
    TEMP: NETDEVICE.FRONT.TEMP,
    RESPONSETIME: NETDEVICE.FRONT.RESPONSETIME,
    SYSLOG: NETDEVICE.FRONT.SYSLOG,
    SNMPTRAP: NETDEVICE.FRONT.SNMPTRAP,
    TRAFFIC: NETDEVICE.FRONT.TRAFFIC,
  },
  BACK: {
    CLIENT: [
      { rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'CLIENT_COUNT', rscKey: '_' },
    ],
    ROGUE: [
      { rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'ROGUE_AP_COUNT', rscKey: '_' },
    ],
    WIRELESSAP_TOPN: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_' },
    ],
    POWER: NETDEVICE.BACK.POWER,
    CPU: NETDEVICE.BACK.CPU,
    MEM: NETDEVICE.BACK.MEM,
    TEMP: NETDEVICE.BACK.TEMP,
    RESPONSETIME: NETDEVICE.BACK.RESPONSETIME,
    SYSLOG: NETDEVICE.BACK.SYSLOG,
    SNMPTRAP: NETDEVICE.BACK.SNMPTRAP,
    TRAFFIC: NETDEVICE.BACK.TRAFFIC,
  },
};

export const WIRELESS_AP = {
  FRONT: {
    CLIENT: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_' },
    ],
    SNR: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_SNR', rscKey: '_' },
    ],
	RSSI: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_RSSI', rscKey: '_' },
    ],
    TRAFFIC_TOPN: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_' },
    ],
  },
  BACK: {
    CLIENT: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_' },
    ],
    SNR: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_SNR', rscKey: '_' },
    ],
	RSSI: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_RSSI', rscKey: '_' },
    ],
    TRAFFIC_TOPN: [
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_' },
      { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/constants/summary.js